import React from 'react';
import * as C from "../componentsM/index";
import { Link } from 'react-router-dom';
import myp from '../assets/PYP-Eng-logo-522x522.jpg';

import myp2 from '../assets/MYP-Language-Group.png';

const International = () => <>

    <C.Hero title={"INTERNATIONAL BACCALAUREATE MIDDLE YEARS PROGRAMME"} image={"/hero/11.jpg"} />


    <section className='p-4 md:p-24'>

        <div className='flex flex-col gap-3 my-4'>

            <h1 className='text-xl md:text-4xl font-bold text-myBlue'>The MYP at TIS is:</h1>

            <ul className="list-disc list-inside my-2">
                {[
                    "For students aged 11 to 16",
                    "a frameworks of academic challenge",
                    "8 subject groups, plus interdisciplinary learning in years 1-3",
                    "6 subject groups, plus interdisciplinary learning and the personal project in years 4-5",
                    "Taught in English"
                ].map(v => <li key={v} className='my-2 font-semibold'>{v}</li>)}
            </ul>



        </div>

        <div className='flex flex-col gap-3 my-4'>

            <h1 className='text-xl md:text-4xl font-bold text-myBlue'>The MYP encourages students to:</h1>

            <ul className="list-disc list-inside my-2">
                {[
                    "Understand the connections between subjects through interdisciplinary learning",
                    "Understand the connections between subjects and the real world",
                    "become critical and reflective thinkers"
                ].map(v => <li key={v} className='my-2 font-semibold'>{v}</li>)}
            </ul>



        </div>

        <div className='flex flex-col gap-3 my-4'>

            <h1 className='text-xl md:text-4xl font-bold text-myBlue'>MYP Model:</h1>

            <figure className="mx-auto w-1/2"><img src={myp}  className="w-full h-full object-contain" /></figure>


        </div>



        <div className='flex flex-col gap-3 my-4'>

            <h1 className='text-xl md:text-4xl font-bold text-myBlue'>Learner Profile</h1>

            <h6 className='mb-4'>The attributes of the <Link className='text-myBlue/60' to="/INTERNATIONAL-BACCALAUREATE">Learner Profile</Link> express the values inherent to the IB continuum of international education.</h6>

            <h6 className='mb-4'>IB programmes promote the education of the whole person, emphasising intellectual, personal, emotional and social growth through all domains of knowledge.</h6>


        </div>



        <div className='flex flex-col gap-3 my-4'>

            <h1 className='text-xl md:text-4xl font-bold text-myBlue'>Why the Middle Years programme?</h1>

            <h6>Parents who want the best possible education for their children choose the MYP because it includes:</h6>

            <ul className="list-disc list-inside my-2">
                {[
                    "Rigorous learning objectives",
                    "A student-centred approach to teaching",
                    "International perspectives",
                    "Concern for the whole child",
                    "Sustained teaching and learning in more than one language",
                    "A focus on learning how to learn",
                    "The development of flexible thinking that prepares students to evaluate information critically and apply knowledge in complex, unfamiliar situations."
                ].map(v => <li key={v} className='my-2 font-semibold'>{v}</li>)}
            </ul>

            <p>The MYP teaches tools for lifelong learning and fosters responsible attitudes that help students discover how to use what they learn to take principled action. The MYP’s focus on independent learning makes it the ideal preparation for the IB Diploma Programme (DP) and the IB Career-related Certificate (IBCC).</p>


            <h6>MYP Subject Groups</h6>
            <h6>All courses or subjects are grouped in the following 8 disciplines:</h6>
            <h6>Language and Literature:</h6>
            <h6>The school’s language of instruction, English</h6>

            <h6>Language Acquisition:</h6>
            <h6>Urdu, Arabic, French</h6>
            <h6>Individuals and Societies:</h6>
            <h6>History, Integrated Humanities</h6>
            <h6>Sciences:</h6>
            <h6>Biology, Chemistry, Physics.</h6>
            <h6>Mathematics:</h6>
            <h6>Course including the five branches of mathematics: number, algebra, geometry and trigonometry, probability and statistics, and discrete mathematics.</h6>
            <h6>Arts:</h6>
            <h6>Visual Arts and Performing Arts.</h6>
            <h6>Physical and Health Education: </h6>
            <h6>Course includes health and fitness, individual and team sports.</h6>
            <h6>Design:</h6>
            <h6>Digital and product design</h6>


            <figure className="mx-auto w-1/2"><img src={myp2} className="w-full h-full object-contain" /></figure>

        </div>



<div>
    <h6>Distinctive features of the MYP</h6>
    <p>In the MYP, students study 8 subject groups, with a minimum of 50 teaching hours per subject group each year. Distinctive features of the MYP include:</p>
</div>

    </section>

</>

export default International